import { onMounted, onUnmounted } from "vue";

export function useZoomSticky(threshold = 4) {
  const handleZoom = () => {
    const zoom = window.screen.width / window.innerWidth;

    if (zoom >= threshold) {
      document.body.classList.add("user-is-zooming");
    } else {
      document.body.classList.remove("user-is-zooming");
    }
  };

  onMounted(() => {
    handleZoom();
    window.addEventListener("resize", handleZoom);
  });

  onUnmounted(() => {
    window.removeEventListener("resize", handleZoom);
  });
}
